<template>
  <div class="mx-auto">
    <div class="mb-6 flex flex-col items-center text-center">
      <div class="flex size-24 items-center justify-center rounded-full bg-product-search-related">
        <Icon class="h-[45px] w-[46px] text-illustration-red" name="house-delivery" />
      </div>

      <div class="mt-6 text-lg font-semibold">{{ props.title }}</div>
    </div>
    <div v-if="props.suggestions && nonEmptySuggestionItems.length" class="flex flex-col items-center justify-center border-y border-border-medium py-6">
      {{ props.suggestions.title }}
      <ul class="mt-2">
        <li v-for="(suggestion, index) in nonEmptySuggestionItems" :key="index" class="ml-6 list-disc">{{ suggestion }}</li>
      </ul>
    </div>
    <div class="no-results__link-wrapper mt-6 text-center text-lg" v-html="props.bottomText" />
  </div>
</template>

<script setup lang="ts">
interface TSuggestions {
  title: string
  items: string[]
}

const props = withDefaults(
  defineProps<{
    title?: string | null
    suggestions?: TSuggestions | null
    bottomText?: string | null
  }>(),
  {
    title: null,
    suggestions: null,
    bottomText: null,
  }
)

const nonEmptySuggestionItems = computed(() => {
  return props.suggestions?.items.filter((item) => item.length) ?? []
})
</script>

<style lang="scss" scoped>
.no-results__link-wrapper:deep(a) {
  @apply text-text-strong underline hover:no-underline;
}
</style>
